module.exports = __webpack_public_path__ + "img/ms-icon.363fdd53.svg";